import { HttpClient } from '../../gateways'
import { UnexpectedError } from '../../models/errors'
import { setupIntranetV2ApiClient } from '../../proxies/apis/intranet-v2'
import { HttpStatusCode } from '../../types/gateways'

export const obterRelatorioConsumoAlmoco = async (input?: { params?: any }) => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/restaurante/relatorio-consumo-almoco',
    method: 'GET',
    params: input?.params
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return response.body
    default:
      throw new UnexpectedError()
  }
}
